import Route from '@ember/routing/route'

export default class SubscriptionTypeIndexRoute extends Route {}
